import React, { useEffect, useRef, useState } from 'react';
import { ImCross } from "react-icons/im";
import {toast } from 'react-toastify';
import { BsCloudUpload } from "react-icons/bs";
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/reset.css';
import moment from 'moment';
import dayjs from 'dayjs';
import Switch from 'react-switch';
import { GoogleMap, LoadScript, Marker, Circle } from '@react-google-maps/api';
import axios from 'axios';
import './popup.css';
import Autocomplete from 'react-google-autocomplete';
import { TextField,  Button, FormControlLabel } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
const PopupSellar = ({ Cross, id ,fetchData,editData}) => {
   const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    Owner: id,
    shopName: '',
    shopDetails: '',
    cost: '',
    uploadCover: null,
    city: '',
    isActive: true,
    radius: '' || 0,
    markerPosition: { lat: 25.354826, lng: 55.381007 }, // Sharjah
    parkingPositions: [],
    location: {
      country_city: "UAE , Dubai",
      text: "Istiqlal Street - near Immigration Office - Bu Danig - Sharjah - United Arab Emirates",
      lat: ''||24.8500,
      long: '' ||67.0500,
    },
    estimatedServiceTime: "",
    timing: {
      monday: { open: false, from: '', to: '' },
      tuesday: { open: false, from: '', to: '' },
      wednesday: { open: false, from: '', to: '' },
      thursday: { open: false, from: '', to: '' },
      friday: { open: false, from: '', to: '' },
      saturday: { open: false, from: '', to: '' },
      sunday: { open: false, from: '', to: '' },
    },
  });
  const formatTime = (dateTime) => {
    if (!dateTime) return '';
    const date = new Date(dateTime);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };
  
  const [error, setError] = useState('');

  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState('');

 const token = localStorage.getItem('accessToken')

const handleTimeChange = (day, type, time) => {
  const isoTime = time ? new Date(time).toISOString() : '';

  setFormData((prev) => ({
    ...prev,
    timing: {
      ...prev.timing,
      [day]: {
        ...prev.timing[day],
        [type]: isoTime,
        open: true,
      },
    },
  }));
};

 
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setFileName(file ? file.name : '');
  
    if (!file) {
      toast.error("Please select a valid file");
      return;
    }
  
    // Check file size (1MB = 1024 * 1024 bytes)
    if (file.size > 1024 * 1024) {
      toast.error("File size must be smaller than 1MB.");
      return; // Prevent further actions if the file is too large
    }
  
    try {
      const uploadFormData = new FormData();
      uploadFormData.append('file', file);
  
      // Set uploading state (optional, for a loader)
      setUploading(true);
  
      // Upload the file
      const uploadResponse = await axios.post('https://backend.washta.com/api/uploadFile', uploadFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`, // Ensure your token is correct
        },
      });
  
      // Save the uploaded image URL in formData
      const uploadedImageUrl = uploadResponse?.data?.data?.path;
  
      if (uploadedImageUrl) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          uploadCover: uploadedImageUrl, // Save the image URL
        }));
        toast.success("Image uploaded successfully!");
      } else {
        throw new Error("Failed to upload image. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Error uploading image. Please try again.");
    } finally {
      setUploading(false); // Reset uploading state
    }
  };

  useEffect(() => {
    if (editData) {
      const updatedTiming = {};
  
      // Loop through the timing object and handle each day
      Object.keys(editData.timing).forEach((day) => {
        const timeFrom = editData.timing[day].from;
        const timeTo = editData.timing[day].to;
  
        // Parse the 'from' and 'to' times, ensuring they're correctly handled
        const formattedFrom = moment(timeFrom, ['MM/DD/YYYY, HH:mm:ss', 'HH:mm']).isValid()
          ? moment(timeFrom, ['MM/DD/YYYY, HH:mm:ss', 'HH:mm']).format('MM/DD/YYYY, HH:mm:ss')
          : timeFrom;
  
        const formattedTo = moment(timeTo, ['MM/DD/YYYY, HH:mm:ss', 'HH:mm']).isValid()
          ? moment(timeTo, ['MM/DD/YYYY, HH:mm:ss', 'HH:mm']).format('MM/DD/YYYY, HH:mm:ss')
          : timeTo;
  
        // Add the formatted times to the updated timing object
        updatedTiming[day] = {
          ...editData.timing[day],
          from: formattedFrom,
          to: formattedTo,
        };
      });
  
      setFormData({
        ...formData,
        Owner: editData.Owner,
        shopName: editData.shopName,
        shopDetails: editData.shopDetails,
        cost: editData.cost,
        uploadCover: editData.coverImage, // Handle if coverImage should be uploaded
        city: '', // Update if you have a field for city
        isActive: editData.isActive,
        radius: editData.radius,
        location: {
          country_city: "UAE , Dubai", // Can be updated if city info is available
          text: editData.location.text,
          lat: editData.location.coordinates[1],
          long: editData.location.coordinates[0],
        },
        estimatedServiceTime: editData.estimatedServiceTime,
        timing: updatedTiming, // Set the updated timing here
      });
    }
  }, [editData]);
  
  

const handleActiveChange = (day) => {
    setFormData((prev) => ({
      ...prev,
      timing: {
        ...prev.timing,
        [day]: {
          ...prev.timing[day],
          open: !prev.timing[day].open,
          from: '',
          to: '',
        },
      },
    }));
  };





const handlePlaceSelected = (place) => {
  if (place && place.geometry) {
    const addressComponents = place.address_components;
    
    // Extract city and country from the address components
    const city = addressComponents.find(component => 
      component.types.includes("locality") || component.types.includes("administrative_area_level_1")
    )?.long_name || '';
    
    const country = addressComponents.find(component => 
      component.types.includes("country")
    )?.long_name || '';

    setFormData((prevData) => ({
      ...prevData,
      city: city, 
      location: {
        country_city: `${country}, ${city}`, // Fixing template literal syntax
        text: place.formatted_address, 
        lat: place.geometry.location.lat(), 
        long: place.geometry.location.lng(),
      },
      markerPosition: {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      },
      radius: formData.radius || 0, // Default radius if not specified
    }));
    console.log(' lat', place.geometry.location.lat(), 
        "long", place.geometry.location.lng())
  }
};
const generateParkingPositions = (center, radiusInKm) => {
  const radiusInMeters = radiusInKm * 1000; // Convert km to meters
  const positions = [];
  const numMarkers = Math.floor(Math.random() * 20) + 5; // Random number between 5 and 20 markers

  // Generate parking spots as random locations inside the radius
  for (let i = 0; i < numMarkers; i++) {
    const angle = Math.random() * 2 * Math.PI; // Random angle
    const distance = Math.random() * radiusInMeters; // Random distance within radius

    // Calculate the offset in latitude/longitude based on the radius
    const offsetLat = distance * Math.sin(angle) / 111300; // Convert meters to degrees for latitude
    const offsetLng = distance * Math.cos(angle) / (111300 * Math.cos(center.lat * Math.PI / 180)); // Convert meters to degrees for longitude

    positions.push({
      lat: center.lat + offsetLat,
      lng: center.lng + offsetLng,
    });
  }

  return positions;
};

const handleRadiusChange = (e) => {
  const newRadius = e.target.value;
  setFormData((prevData) => ({
    ...prevData,
    radius: newRadius,
    parkingPositions: generateParkingPositions(prevData.markerPosition, newRadius), // Generate parking markers based on the radius
  }));
};

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setFormData({
      ...formData,
      markerPosition: { lat, lng },
    });
  };

  // const geocodeAddress = (address) => {
  //   const geocoder = new window.google.maps.Geocoder();
  //   console.log("Geocoding address:", address);  // Log the address
  //   geocoder.geocode({ address: address }, (results, status) => {
  //     console.log("Geocode results:", results);  // Log the results
  //     console.log("Geocode status:", status);    // Log the status
  //     if (status === 'OK') {
  //       const position = results[0].geometry.location;
  //       setFormData({
  //         ...formData,
  //         markerPosition: { lat: position.lat(), lng: position.lng() },
  //       });
  //     } else {
  //       console.log('Geocode was not successful for the following reason: ' + status);
  //     }
  //   });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const triggerFileInput = () => {
    document.getElementById("file-input").click();
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  // Validate required fields
  if (!validateStep1()) return;



  setUploading(true);


  try {

        const payload = {
      shopName: formData.shopName,
      coverImage: formData.uploadCover || editData?.coverImage, // Use the new or existing image URL
      isActive: true,
      shopDetails: formData.shopDetails,
      location: {
        text: formData.location.text,
        _id: formData.location._id, 
        lat: formData.location.lat,
        long: formData.location.long,
            coordinates: [
         formData.location.lat,
        formData.location.long
            ]
      },
      timing: Object.keys(formData.timing).reduce((acc, day) => {
            acc[day] = {
              open: formData.timing[day].open,
              from: formatTime(formData.timing[day].from),  // Format time
              to: formatTime(formData.timing[day].to),      // Format time
            };
            return acc;
          }, {}),
      cost: formData.cost,
      radius: formData.radius,
      estimatedServiceTime: formData.estimatedServiceTime
    };

    // Determine endpoint and method
    const apiEndpoint = editData ? `/api/seller/shop/${editData._id}` : '/api/seller/shop';
    const httpMethod = editData ? 'PATCH' : 'POST';

    // Make the API call
    const response = await axios({
      method: httpMethod,
      url: `https://backend.washta.com${apiEndpoint}`,
      data: payload,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      toast.success(editData ? 'Update successful' : ' New shop saved');
      fetchData(); // Refresh data
      Cross(); // Close popup
    } else {
      toast.error('Failed to submit shop details');
    }
  } catch (error) {
    if (error.response?.status === 409) {
      toast.error('Shop name is already exists plz select choose another shop name');
    }
    if (error.response?.status === 429) {
      toast.error('Too many requests, please try again later.');
    } else {
      console.error('Error:', error);
      // toast.error('Error submitting shop details');
    }
  } finally {
    setUploading(false);
  }
};




// Validate Step 1
const validateStep1 = () => {
  if (!formData.shopName || !formData.shopDetails || !formData.cost || !formData.uploadCover) {
    toast.error('Please fill out all fields/upload image');
    return false;
  }
  setError('');  // Clear error message
  return true;
};

  const validateStep2 = () => {
    let isAnyActive = false; 
    let hasError = false; 
    let errorMessages = []; // To accumulate error messages
    
    for (const day in formData.timing) {
      const { from, to, open } = formData.timing[day];
      
      if (open) { // Check if the day is active
        isAnyActive = true;
        if (!from || !to) {
          const errorMessage = `Please fill in start and end times for ${day.charAt(0).toUpperCase() + day.slice(1)}.`;
          errorMessages.push(errorMessage); // Accumulate error messages
          setError(errorMessage); // Set the error state for the latest error
          toast.error(errorMessage); // Show toast notification for the latest error
          hasError = true; // Set the error flag
        }
      }
    }
  
    // Check if at least one day is active
    if (!isAnyActive) {
      const errorMessage = 'Please activate at least one day.';
      errorMessages.push(errorMessage); // Accumulate error messages
      setError(errorMessage); // Set the error state
      toast.error(errorMessage); // Show toast notification
      return false; // Prevent navigation
    }
  
    // If there is an error, prevent navigation
    if (hasError) {
      return false; // Prevent navigation if there are errors
    }
  
    // If you want to show all accumulated error messages:
    if (errorMessages.length > 0) {
      toast.error(errorMessages.join('\n')); // Show all accumulated error messages at once
    }
  
    setError(''); // Clear error if all active days are valid
    return true; // Pass validation
  };
  
  
  
  const validateStep3 = () => {
    if (!formData.selectedCity || !formData.radius) {
      toast.error('Please fill all fields');
      return false;
    }
    setError(''); // Clear error if fields are valid
    return true;
  };

  const nextStep = () => {
    if (step === 1 && !validateStep1()) return;
    if (step === 2 && !validateStep2()) return;
    if (step === 3 && !validateStep3()) return;
    setStep((prevStep) => prevStep + 1);
  };

  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
  };
  const preventWheel = (e) => {
    e.preventDefault(); // Scroll ko prevent karega
  };
  const handleFocus = (e) => {
    e.target.addEventListener('wheel', preventWheel, { passive: false });

  };
  return (
    <div className="app">
      <div className="popup-background">
        <div className="popup">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h2>Shop {step === 1 ? "Details" : step === 2 ? "timing" : "Location"}</h2>
            <ImCross style={{ color: '#8891F1', cursor: 'pointer' }} onClick={Cross} className="close-icon" />
          </div>
          {step === 1 && (
            <>
              <label className='label-popup-seller'>Shop Name <sup>*</sup></label>
              <input
                type="text"
                name="shopName"
                placeholder="Shop name*"
                value={formData.shopName}
                onChange={handleChange}
              />
              <label className='label-popup-seller'>Shop Details <sup>*</sup></label>
              <input
                type="text"
                name="shopDetails"
                placeholder="Shop details"
                value={formData.shopDetails}
                onChange={handleChange}
              />
              <div className='addtion-spantag'>
              <label className='label-popup-seller '>Price <sup>*</sup></label>
              <input
                type="number"
                name="cost"
                placeholder="AED"
                value={formData.cost}
                onFocus={handleFocus} 
                onChange={handleChange}
              />
              <span className='span-tag-popup'>AED</span>
              </div>
             
              <div>
      <input
        type="file"
        id="file-input"
        style={{ display: "none" }}
        accept=".png, .jpg, .jpeg"
        onChange={handleFileChange}
      />
     
     
<button
  onClick={triggerFileInput}
  className={`btn-right flex items-center ${formData?.uploadCover ? "justify-start" : "justify-center"} rounded-[40px] px-[10px] py-[14px]`}
>
  {formData?.uploadCover && formData.uploadCover !== "" ? (
    // If there's an uploaded image, show the image and the "Update Image" text
    <>
      <img style={{border:'1px solid white'}} src={formData.uploadCover} alt="Uploaded" className="mr-2 w-10 h-10 rounded-full" />
      Update Image
    </>
  ) : (
    // If no image, show the upload icon and the "Upload Image" text
    <>
      <BsCloudUpload className="mr-2 text-2xl" />
      Upload Image
    </>
  )}
</button>


    </div>
              <div className='row-popup'>
                <button className='btn-left' onClick={Cross}>Cancel</button>
                <button className='btn-right' onClick={nextStep}>Continue</button>
              </div>
            </>
          )}
          {step === 2 && (
            <>
            
              <LocalizationProvider dateAdapter={AdapterDayjs}>
      {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day) => (
        <div key={day} className="timing-row">
          <div className='week-part'>
            <label>{day.charAt(0).toUpperCase() + day.slice(1)}</label>
          </div>
          <div className="timing-row">
            <div style={{ marginBottom: 8 }}>
              <p style={{ margin: 0, fontSize: 10 }}>Start Time</p>
              <TimePicker
               size="small"
              //  sx={{ width: '120px',margin:0,padding:0}}
              sx={{
                width: 120, // Adjust width as needed
                '& .MuiInputBase-root': {
                  backgroundColor: '#f5f5f5 !important', // Background color with !important
                },
                '& .MuiInputBase-input': {
                  color: '#333 !important', // Text color with !important
                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'red !important', // Red border with !important on focus
                },
              }}
 value={
  formData.timing[day]['from']
    ? dayjs(formData.timing[day]['from'])  // from ISO format
    : null
}
onChange={(time) => handleTimeChange(day, 'from', time)}
  format="HH:mm"
  disabled={!formData.timing[day].open}
/>

            </div>
            <div style={{ marginBottom: 8 }}>
              <p style={{ margin: 0, fontSize: 10 }}>End Time</p>
              <TimePicker
               size="small"
               sx={{ width: '120px' }}
              value={
                formData.timing[day]['to']
                  ? dayjs(formData.timing[day]['to'])  // from ISO format
                  : null
              }
              onChange={(time) => handleTimeChange(day, 'to', time)}
  format="HH:mm"
  disabled={!formData.timing[day].open}
/>
            </div>

             <Switch
             onChange={() => handleActiveChange(day)}

             checked={formData.timing[day].open}
                      onColor="#747EEF"
                      offColor="#bcbcbc"
                      handleDiameter={17}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={36}
                    />
          </div>
        </div>
      ))}
       <div className='row-popup'>
                <button className='btn-left' onClick={prevStep}>Back</button>
                <button className='btn-right' onClick={nextStep}>Continue</button>
              </div>
    </LocalizationProvider>
            </>
          )}
          {step === 3 && (
            <>
                 <div className='addtion-spantag'>
               <label className='label-popup-seller'>Estimated Service Timing <sup>*</sup></label>
               <input
                 type="number"
                name="estimatedServiceTime"
                placeholder="Estimated Service Timing*"
                value={formData.estimatedServiceTime}
                onChange={handleChange}
                onFocus={handleFocus} 
              />
                <span className='span-tag-popup'>Minutes</span>
              </div>
             <label className='label-popup-seller'>Location <sup>*</sup></label>
{/* ////// AIzaSyD6igDr18WE4pLBMLREICWnBU52NhTrQCY this is washta.me@gmail.com google console cloud generated and project name washta        */}
       
    <LoadScript googleMapsApiKey="AIzaSyDkYZEMg8ZH5EhRqdkLF-GyeHrhpZBlSd0" libraries={['places']}>
        <Autocomplete
          onLoad={(autocomplete) => console.log('Autocomplete Loaded:', autocomplete)}
          onPlaceSelected={handlePlaceSelected}
          options={{
            types: ['establishment', 'geocode'],
            componentRestrictions: { country: 'AE' },
          }}
          placeholder="Search for an address"
          style={{
            width: '100%',
            height: '40px',
            padding: '10px',
            boxSizing: 'border-box',
            borderRadius: '4px',
            border: '1px solid #ccc',
            marginBottom: '20px',
          }}
        />
      </LoadScript>
       
        <label className='label-popup-seller'>Radius (in meter) <sup>*</sup></label>
        <input
          type="number"
          name="radius"
          placeholder="Enter radius"
          value={formData.radius}
          // onChange={handleChange}
           min="0"
          onChange={handleRadiusChange}

          onFocus={handleFocus} 
        />
       
       <LoadScript
  googleMapsApiKey="AIzaSyDkYZEMg8ZH5EhRqdkLF-GyeHrhpZBlSd0"
  libraries={['places']}
  async
  defer
>
        
          <GoogleMap
          mapContainerStyle={{ height: '300px', width: '100%' }}
          center={formData.markerPosition}
          zoom={12}
          onClick={handleMapClick}
        >
          <Marker position={formData.markerPosition} />
          {formData.radius && (
            <Circle
              center={formData.markerPosition}
              radius={parseFloat(formData.radius) * 1000}
              options={{
                fillColor: 'rgba(136, 145, 241, 0.3)',
                strokeColor: '#8891F1',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
            />
          )}

          {/* Parking marker */}
          {formData?.parkingPositions.map((position, index) => (
  <Marker
  key={index}
  position={position}
  icon={{
    url: 'data:image/svg+xml;base64,' + btoa(`
      
     <svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2.5" y="2.5" width="64" height="64" rx="32" fill="#747EEF"/>
<rect x="2.5" y="2.5" width="64" height="64" rx="32" stroke="white" stroke-width="5"/>
<path d="M23.1716 49V21H35.2916C37.7982 21 39.9582 21.4133 41.7716 22.24C43.5849 23.04 44.9849 24.2 45.9716 25.72C46.9582 27.24 47.4516 29.0533 47.4516 31.16C47.4516 33.24 46.9582 35.04 45.9716 36.56C44.9849 38.08 43.5849 39.2533 41.7716 40.08C39.9582 40.88 37.7982 41.28 35.2916 41.28H26.7716L29.6516 38.36V49H23.1716ZM29.6516 39.08L26.7716 36H34.9316C36.9316 36 38.4249 35.5733 39.4116 34.72C40.3982 33.8667 40.8916 32.68 40.8916 31.16C40.8916 29.6133 40.3982 28.4133 39.4116 27.56C38.4249 26.7067 36.9316 26.28 34.9316 26.28H26.7716L29.6516 23.2V39.08Z" fill="white"/>
</svg>

    `), // Custom SVG icon with updated styles
    scaledSize: new window.google.maps.Size(30, 30), // Adjust size for better visibility
    anchor: new window.google.maps.Point(30, 20), // Adjust anchor point for proper alignment
  }}
/>


))}

        </GoogleMap>
        </LoadScript>
        <div className='row-popup'>
          <button className='btn-left' onClick={prevStep}>Back</button>
          <button className='btn-right' onClick={handleSubmit} disabled={uploading}>
    {uploading ? 'Uploading...' : editData ? 'Update' : 'Submit'}
</button>
        </div>
            </>
          )}
        
        </div>
      </div>
    </div>
  );
};

export default PopupSellar;